import { gsap, Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { titleColors } from "./vars";
import { isMobile } from "./uilts";



class Intro {

    sectionIntro;       // 인트로 루트 세션 엘리먼트.
    titleTimeline;
    titleImgList;       // 타이틀 중앙 사진 이미지 목록.

    mainseedTimeline;   // 메인시드용 타임라인.
    mainseed;           // 메인 시드.
    clusterSectionElem;

    // =============== 색상변경용 엘리먼트 목록.
    titleNumber1Elem;           // 1.
    titleNumber0Elem;           // 0.
    titleTextTHElem;            // TH.
    titleTextAnniversaryElem;   // Anniversary.
    titleOrbitInnerList;        // 공전 내부 원형 파티클 목록.
    titleOrbitOuterList;        // 공전 외부 원형 파티클 목록.
    title10thOrbitElem;         // 10th 내 공전 원형 엘리먼트.

    orbitInnerContainer;
    orbitOuterContainer;
    backgroundRotateParticles;

    constructor() {
        this.clusterSectionElem = document.getElementById('impact-cluster');
        this.sectionIntro = document.getElementById('intro');
        this.title10thOrbitElem = this.sectionIntro.querySelector('#orbital-circle');

        this.titleNumber1Elem = this.sectionIntro.querySelector('#titleNumber1');
        this.titleNumber0Elem = this.sectionIntro.querySelector('#titleNumber0');
        this.titleTextTHElem = this.sectionIntro.querySelector('#titleTextTH');
        this.titleTextAnniversaryElem = this.sectionIntro.querySelector('#titleAnniversary');
        this.titleOrbitInnerList = gsap.utils.toArray('#innerParticle'); 
        this.titleOrbitOuterList = gsap.utils.toArray('#outerParticle');
        this.titleImgList = gsap.utils.toArray('#title-img');

        this.mainseed = document.querySelector('.seed-wrapper.main-seed');


        this.orbitInnerContainer = document.querySelector('.container-rotate.inner');
        this.orbitOuterContainer = document.querySelector('.container-rotate.outer');
        this.backgroundRotateParticles = gsap.utils.toArray('.intro-particle-orbit');
    }

    init() {
        // Scroll To Next 버튼 애니메이션.
        if(document.querySelector('.scroll-down-wrapper.intro .scroll-contents').childElementCount === 0) {
            bodymovin.loadAnimation({
                container: document.querySelector('.scroll-down-wrapper.intro .scroll-contents'),
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: './assets/lottie/PC_Intro_1_01-08_Scroll.json'
            });
        }
        this.mainseedTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.clusterSectionElem,
                start: "center bottom",
                end: "bottom bottom",
                scrub: 1,
                invalidateOnRefresh: true,
                // markers: true,
                id: 'main-seed-first',
                preventOverlaps: true,
                fastScrollEnd: true,
                onEnter: () => {
                    this.animateRotation(true);
                },
                onLeave: () => {
                    // console.log('stop Rotate!');
                    this.animateRotation(false);
                },
                onLeaveBack: () => {
                    // console.log('play Rotate!');
                    this.animateRotation(true);
                }
            }
        })
        this.titleTimeline = gsap.timeline({
            repeat: -1,
            paused: true
        });

        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 45, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(2);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 90, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(3);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 135, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(4);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 180, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(5);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 225, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(6);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 270, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(7);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 315, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(8);
        // this.titleTimeline.to(this.title10thOrbitElem, {rotation: 360, transformOrigin: 'center 180', duration: 2, ease: Linear.easeNone});
        this.titleTimeline.to({}, {duration: 2});
        this.changeNextTitle(1)                                        
        this.mainseedTimeline.to(this.sectionIntro, {autoAlpha: 0, duration: 5});
        // this.mainseedTimeline.to(this.sectionIntro, {autoAlpha: 0, duration: 10},"-=5");
        
        if(isMobile()) {

            // 메인 씨드 드랍.
            this.mainseedTimeline.fromTo(this.mainseed, {y: () => -window.innerHeight / 2}, {y: 0, duration: 60}, "-=5");
            this.mainseedTimeline.fromTo(this.mainseed, {opacity: 0}, {opacity: 1, duration: 10}, "-=60");
        
        } else {
            // 메인 씨드 드랍.
            this.mainseedTimeline.fromTo(this.mainseed, {y: () => -window.innerHeight / 2}, {y: 0, duration: 35}, "-=5");
            this.mainseedTimeline.fromTo(this.mainseed, {opacity: 0}, {opacity: 1, duration: 10}, "-=35");
        }
        return Promise.resolve()
    }

    kill() {
        this.mainseedTimeline.clear().kill();
        this.mainseedTimeline = null;
    }

    // window resize 이벤트 호출시 동작.
    refresh() {
        this.mainseedTimeline.invalidate();
    }

    changeNextTitle(num) {
        const idx = (num > 4 ? num - 5 : num - 1).toString();
        // console.log(titleColors[idx]);
        this.titleTimeline.set(this.titleNumber1Elem, {attr: { fill: titleColors[idx].number1 }});
        this.titleTimeline.set(this.titleNumber0Elem, {attr: { fill: titleColors[idx].number0 }});
        this.titleTimeline.set(this.titleTextTHElem, {attr: { fill: titleColors[idx].th }});
        this.titleTimeline.set(this.titleTextAnniversaryElem, { attr: { fill: titleColors[idx].anniversary } });
        this.titleTimeline.set(this.title10thOrbitElem, { attr: { fill: titleColors[idx].orbit0 } });

        for (let i = 0; i < titleColors[idx].innerParticles.length; i++) {
            this.titleTimeline.set(this.titleOrbitInnerList[i], {attr: { fill: titleColors[idx].innerParticles[i] }});    
        }
        for (let i = 0; i < titleColors[idx].outerParticles.length; i++) {
            this.titleTimeline.set(this.titleOrbitOuterList[i], {attr: { fill: titleColors[idx].outerParticles[i] }});    
        }
        for (let i = 0; i < this.titleImgList.length; i++) {
            if (i === num - 1)  this.titleTimeline.set(this.titleImgList[i], { opacity: 1 });
            else                this.titleTimeline.set(this.titleImgList[i], { opacity: 0 });
        }
    }

    getTimeline() {
        return this.mainseedTimeline;
    }
    getScrollTrigger() {
        return this.mainseedTimeline.scrollTrigger;
    }

    playIntro() {
        this.titleTimeline.play();
    }

    /**
     * 
     * @param {boolean} running 애니메이션 재생 여부
     */
    animateRotation(running) {
        if (running) {
            if (this.orbitInnerContainer.classList.contains('stop-animate')) this.orbitInnerContainer.classList.remove('stop-animate');
            if (this.orbitOuterContainer.classList.contains('stop-animate')) this.orbitOuterContainer.classList.remove('stop-animate');
            this.backgroundRotateParticles.forEach((particle) => {
                if (particle.classList.contains('stop-animate')) particle.classList.remove('stop-animate');
            });
        } else {
            if (!this.orbitInnerContainer.classList.contains('stop-animate')) this.orbitInnerContainer.classList.add('stop-animate');
            if (!this.orbitOuterContainer.classList.contains('stop-animate')) this.orbitOuterContainer.classList.add('stop-animate');
            this.backgroundRotateParticles.forEach((particle) => {
                if (!particle.classList.contains('stop-animate')) particle.classList.add('stop-animate');
            });
        }
    }
}

export default Intro;